import type { GridsterItemConfig } from 'angular-gridster2';

export type DashboardWidgetType =
  | 'kpi-collection'
  | 'kpi-projection'
  | 'kpi-pending'
  | 'kpi-rate'
  | 'sales-chart'
  | 'collection-timeline'
  | 'collection-breakdown'
  | 'upcoming-overdue'
  | 'invoice-status'
  | 'recent-payments';

export interface DashboardGridItem extends GridsterItemConfig {
  id: string;
  widgetType: DashboardWidgetType;
}

export const DASHBOARD_LAYOUT_STORAGE_KEY = 'pento-dashboard-layout-v4';
